import React from 'react';
import { EnhancedFloatingFeedbackButton } from './EnhancedFloatingFeedbackButton';
import { TabbedFeedbackChatDialog } from './TabbedFeedbackChatDialog';

/**
 * Enhanced feedback system with tabbed feedback and chat functionality
 */
export const EnhancedFeedbackSystem: React.FC = () => {
  return (
    <>
      <EnhancedFloatingFeedbackButton />
      <TabbedFeedbackChatDialog />
    </>
  );
};
